import $ from 'jquery'
import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getTotalContracts(data) {

		let url = config.api.baseUrl + '/api/contracts/count' + data

		return HTTP
			.request()
			.get(url)
			.then((response) => {

				return response

			})

	},
	getContracts(data) {

		let url = config.api.baseUrl + '/api/contracts' + data

		return HTTP
			.request()
			.get(url)
			.then((response) => {

				return response

			})

	},
	createContract(data) {

		let url = config.api.baseUrl + '/api/contracts'

		return HTTP
			.request()
			.post(url, data)
			.then((response) => {

				return response

			})

	},
	updateContract(data) {

		let url = config.api.baseUrl + '/api/contracts'

		return HTTP
			.request()
			.put(url, data)
			.then((response) => {

				return response

			})

	},
	archiveContract(id) {

		let url = config.api.baseUrl + '/api/contracts/archive/?id=' + id

		return HTTP
			.request()
			.put(url)
			.then((response) => {

				return response

			})

	},
	exportContracts(data) {

		let url = config.api.baseUrl + '/api/contracts/export'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	migrateCSVFile(data) {

		let url = config.api.baseUrl + '/api/contracts/migrate'

		return HTTP
			.request()
			.post(url, data)
			.then((response) => {

				return response

			})

	},
	sendMailDigitalSignature(data) {

		let url = `${config.api.baseUrl}/api/contracts/digital-signature/send-mail`;

		return HTTP.request().put(url, data)

	},
	sendMailAutoRenew(data) {

		let url = `${config.api.baseUrl}/api/contracts/send-mail-auto-renew`;

		return HTTP.request().put(url, data)
	},
	sendMailNewPackages(data) {

		let url = `${config.api.baseUrl}/api/contracts/send-mail-new-packages`;

		return HTTP.request().put(url, data)
	},
	exportZipPDFs(data) {

		let url = config.api.baseUrl + '/api/contracts/exportZipPDFs'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	getExportZipPDFs(archiveId) {

		let url = config.api.baseUrl + '/api/contracts/exportZipPDFs/' + archiveId

		return HTTP
			.request()
			.get(url, {
				responseType: 'arraybuffer',
				onDownloadProgress: function (progressEvent) {

					if (progressEvent.loaded > 0 && progressEvent.total > 0) {

						let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
						$('#progress_id_export_zippdf_download').text(percentCompleted + '%');
						$('#progress_id_export_zippdf_download').attr("aria-valuenow", percentCompleted);
						$('#progress_id_export_zippdf_download').css("width", percentCompleted + "%");

					}

				}
			})
			.then(response => response)
			.catch(error => error)

	},
}



// WEBPACK FOOTER //
// ./src/api/contracts.js